import { HotelBookingRef } from "@/types/hotels/hotels"

import { baseApi } from "./base-api"

export interface NuiteeHolder {
  first_name: string
  last_name: string
  email: string
  phone: string
}

export interface NuiteeLeadGuest {
  occupancy_number: number
  first_name: string
  last_name: string
  remarks?: string
}

export interface PrepareNuiteePaymentArgs {
  bookingRef: HotelBookingRef
  holder?: NuiteeHolder
  guests?: NuiteeLeadGuest[]
}

export interface NuiteePaymentSession {
  stripe_publishable_key: string
  client_secret: string
  return_url: string
}

export const hotelBookingsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    prepareNuiteePayment: builder.mutation<
      NuiteePaymentSession,
      PrepareNuiteePaymentArgs
    >({
      query: ({ bookingRef, holder, guests }) => ({
        url: `/api/hotel-bookings/${bookingRef}/nuitee_payment_session`,
        method: "post",
        data: holder && guests ? { holder, guests } : {},
      }),
    }),
  }),
})

export const { usePrepareNuiteePaymentMutation } = hotelBookingsApi
